// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDocumentCategoryType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DocumentCategoryType implements IDocumentCategoryType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Driver Identity - Name DocumentCategoryType
	**/
    get DriverIdentityName(): IDocumentCategoryType {
        return this.FromId(10);
    }
    /**
		Returns Driver Identity - DOB DocumentCategoryType
	**/
    get DriverIdentityDOB(): IDocumentCategoryType {
        return this.FromId(11);
    }
    /**
		Returns Driver Identity - Authorized Presence DocumentCategoryType
	**/
    get DriverIdentityAuthorizedPresence(): IDocumentCategoryType {
        return this.FromId(12);
    }
    /**
		Returns Driver Identity - Secondary Authorized Presence DocumentCategoryType
	**/
    get DriverIdentitySecondaryAuthorizedPresence(): IDocumentCategoryType {
        return this.FromId(39);
    }
    /**
		Returns Driver Docs - SSN DocumentCategoryType
	**/
    get DriverDocsSSN(): IDocumentCategoryType {
        return this.FromId(13);
    }
    /**
		Returns Driver Docs - Address DocumentCategoryType
	**/
    get DriverDocsAddress(): IDocumentCategoryType {
        return this.FromId(14);
    }
    /**
		Returns Driver Docs - Knowledge & Skills DocumentCategoryType
	**/
    get DriverDocsKnowledgeSkills(): IDocumentCategoryType {
        return this.FromId(18);
    }
    /**
		Returns Driver Docs - Veteran DocumentCategoryType
	**/
    get DriverDocsVeteran(): IDocumentCategoryType {
        return this.FromId(20);
    }
    /**
		Returns Driver Docs - Medical/Vision DocumentCategoryType
	**/
    get DriverDocsMedicalVision(): IDocumentCategoryType {
        return this.FromId(21);
    }
    /**
		Returns Driver  Docs - Driver Experience DocumentCategoryType
	**/
    get DriverDocsDriverExperience(): IDocumentCategoryType {
        return this.FromId(19);
    }
    /**
		Returns Driver Docs - Minor DocumentCategoryType
	**/
    get DriverDocsMinor(): IDocumentCategoryType {
        return this.FromId(17);
    }
    /**
		Returns Driver Identity - Name Change DocumentCategoryType
	**/
    get DriverIdentityNameChange(): IDocumentCategoryType {
        return this.FromId(15);
    }
    /**
		Returns Driver Identity - Gender Change DocumentCategoryType
	**/
    get DriverIdentityGenderChange(): IDocumentCategoryType {
        return this.FromId(16);
    }
    /**
		Returns Placard DocumentCategoryType
	**/
    get Placard(): IDocumentCategoryType {
        return this.FromId(1);
    }
    /**
		Returns Military DocumentCategoryType
	**/
    get Military(): IDocumentCategoryType {
        return this.FromId(2);
    }
    /**
		Returns Fee Exemptions DocumentCategoryType
	**/
    get FeeExemptions(): IDocumentCategoryType {
        return this.FromId(3);
    }
    /**
		Returns Vehicle Ownership DocumentCategoryType
	**/
    get VehicleOwnership(): IDocumentCategoryType {
        return this.FromId(4);
    }
    /**
		Returns Identity DocumentCategoryType
	**/
    get Identity(): IDocumentCategoryType {
        return this.FromId(5);
    }
    /**
		Returns Other DocumentCategoryType
	**/
    get Other(): IDocumentCategoryType {
        return this.FromId(6);
    }
    /**
		Returns MVD Now DocumentCategoryType
	**/
    get MVDNow(): IDocumentCategoryType {
        return this.FromId(7);
    }
    /**
		Returns International Association of Fire Fighters Application DocumentCategoryType
	**/
    get IAFFApplication(): IDocumentCategoryType {
        return this.FromId(8);
    }
    /**
		Returns Fraternal Order of Police Application DocumentCategoryType
	**/
    get FOPApplication(): IDocumentCategoryType {
        return this.FromId(9);
    }
    /**
		Returns Abandoned Vehicle DocumentCategoryType
	**/
    get AbandonedVehicle(): IDocumentCategoryType {
        return this.FromId(22);
    }
    /**
		Returns Additional Documentation DocumentCategoryType
	**/
    get AdditionalDocumentation(): IDocumentCategoryType {
        return this.FromId(23);
    }
    /**
		Returns Court Order DocumentCategoryType
	**/
    get TnRTitleRoleTypeCourtOrder(): IDocumentCategoryType {
        return this.FromId(24);
    }
    /**
		Returns Registration Documents DocumentCategoryType
	**/
    get Registration(): IDocumentCategoryType {
        return this.FromId(25);
    }
    /**
		Returns License Plate Documents DocumentCategoryType
	**/
    get Plate(): IDocumentCategoryType {
        return this.FromId(26);
    }
    /**
		Returns Lien Documents DocumentCategoryType
	**/
    get Lien(): IDocumentCategoryType {
        return this.FromId(27);
    }
    /**
		Returns Permit DocumentCategoryType
	**/
    get Permit(): IDocumentCategoryType {
        return this.FromId(28);
    }
    /**
		Returns Compliance Documents DocumentCategoryType
	**/
    get Compliance(): IDocumentCategoryType {
        return this.FromId(32);
    }
    /**
		Returns Title Summary DocumentCategoryType
	**/
    get TitleSummary(): IDocumentCategoryType {
        return this.FromId(33);
    }
    /**
		Returns Temp License Plate Temp Registration DocumentCategoryType
	**/
    get TempLicensePlateTempRegistration(): IDocumentCategoryType {
        return this.FromId(34);
    }
    /**
		Returns Vehicle Registration DocumentCategoryType
	**/
    get VehicleRegistration(): IDocumentCategoryType {
        return this.FromId(35);
    }
    /**
		Returns Interim Placard DocumentCategoryType
	**/
    get InterimPlacard(): IDocumentCategoryType {
        return this.FromId(36);
    }
    /**
		Returns Vehicle MVR DocumentCategoryType
	**/
    get VehicleMVR(): IDocumentCategoryType {
        return this.FromId(37);
    }
    /**
		Returns Motor Vehicle Record Artifact DocumentCategoryType
	**/
    get MotorVehicleRecordArtifact(): IDocumentCategoryType {
        return this.FromId(38);
    }
    /**
		Returns Refund Receipt DocumentCategoryType
	**/
    get RefundReceipt(): IDocumentCategoryType {
        return this.FromId(40);
    }
    /**
		Returns Payment Receipt DocumentCategoryType
	**/
    get PaymentReceipt(): IDocumentCategoryType {
        return this.FromId(41);
    }
    /**
		Returns Correspondence DocumentCategoryType
	**/
    get Correspondence(): IDocumentCategoryType {
        return this.FromId(42);
    }
    /**
		Returns Proof of Authorized Presence - Standard DocumentCategoryType
	**/
    get ProofofAuthorizedPresenceStandard(): IDocumentCategoryType {
        return this.FromId(43);
    }
    /**
		Returns Proof of Name - Standard DocumentCategoryType
	**/
    get ProofofNameStandard(): IDocumentCategoryType {
        return this.FromId(44);
    }
    /**
		Returns Proof of Name Change DocumentCategoryType
	**/
    get ProofofNameChange(): IDocumentCategoryType {
        return this.FromId(45);
    }
    /**
		Returns Proof of Gender Change DocumentCategoryType
	**/
    get ProofofGenderChange(): IDocumentCategoryType {
        return this.FromId(46);
    }
    /**
		Returns Proof of Date of Birth- Standard DocumentCategoryType
	**/
    get ProofofDateofBirthStandard(): IDocumentCategoryType {
        return this.FromId(47);
    }
    /**
		Returns Vision Screening DocumentCategoryType
	**/
    get VisionScreening(): IDocumentCategoryType {
        return this.FromId(48);
    }
    /**
		Returns Vision Screening Re-Exam DocumentCategoryType
	**/
    get VisionScreeningReExam(): IDocumentCategoryType {
        return this.FromId(49);
    }
    /**
		Returns Vision Exam Report DocumentCategoryType
	**/
    get VisionExamReport(): IDocumentCategoryType {
        return this.FromId(50);
    }
    /**
		Returns Medical Exam Report  DocumentCategoryType
	**/
    get MedicalExamReport(): IDocumentCategoryType {
        return this.FromId(51);
    }
    /**
		Returns Medical Exam Certificate DocumentCategoryType
	**/
    get MedicalExamCertificate(): IDocumentCategoryType {
        return this.FromId(52);
    }
    /**
		Returns Medical Professional Statement DocumentCategoryType
	**/
    get MedicalProfessionalStatement(): IDocumentCategoryType {
        return this.FromId(53);
    }
    /**
		Returns Substance Abuse Evalutation DocumentCategoryType
	**/
    get SubstanceAbuseEvalutation(): IDocumentCategoryType {
        return this.FromId(54);
    }
    /**
		Returns Non Commercial Knowledge DocumentCategoryType
	**/
    get NonCommercialKnowledge(): IDocumentCategoryType {
        return this.FromId(55);
    }
    /**
		Returns Non Commercial Knowledge Re-Exam DocumentCategoryType
	**/
    get NonCommercialKnowledgeReExam(): IDocumentCategoryType {
        return this.FromId(56);
    }
    /**
		Returns Motorcycle Knowledge DocumentCategoryType
	**/
    get MotorcycleKnowledge(): IDocumentCategoryType {
        return this.FromId(57);
    }
    /**
		Returns Class A Knowledge  DocumentCategoryType
	**/
    get ClassAKnowledge(): IDocumentCategoryType {
        return this.FromId(58);
    }
    /**
		Returns Class B Knowledge  DocumentCategoryType
	**/
    get ClassBKnowledge(): IDocumentCategoryType {
        return this.FromId(59);
    }
    /**
		Returns Class C Knowledge  DocumentCategoryType
	**/
    get ClassCKnowledge(): IDocumentCategoryType {
        return this.FromId(60);
    }
    /**
		Returns Double/Triple  Knowledge DocumentCategoryType
	**/
    get DoubleTripleKnowledge(): IDocumentCategoryType {
        return this.FromId(61);
    }
    /**
		Returns Passenger Knowledge DocumentCategoryType
	**/
    get PassengerKnowledge(): IDocumentCategoryType {
        return this.FromId(62);
    }
    /**
		Returns School Bus Knowledge DocumentCategoryType
	**/
    get SchoolBusknowledge(): IDocumentCategoryType {
        return this.FromId(63);
    }
    /**
		Returns Tank Knowledge DocumentCategoryType
	**/
    get TankKnowledge(): IDocumentCategoryType {
        return this.FromId(64);
    }
    /**
		Returns Non Commercial Skill Test DocumentCategoryType
	**/
    get NonCommercialSkillTest(): IDocumentCategoryType {
        return this.FromId(65);
    }
    /**
		Returns Non Commercial Skill Test Re-Exam DocumentCategoryType
	**/
    get NonCommercialSkillTestReExam(): IDocumentCategoryType {
        return this.FromId(66);
    }
    /**
		Returns Motorcycle Skill Test DocumentCategoryType
	**/
    get MotorcycleSkillTest(): IDocumentCategoryType {
        return this.FromId(67);
    }
    /**
		Returns Class A Skill Test DocumentCategoryType
	**/
    get ClassASkillTest(): IDocumentCategoryType {
        return this.FromId(68);
    }
    /**
		Returns Class B Skill Test DocumentCategoryType
	**/
    get ClassBSkillTest(): IDocumentCategoryType {
        return this.FromId(69);
    }
    /**
		Returns Class C Skill Test DocumentCategoryType
	**/
    get ClassCSkillTest(): IDocumentCategoryType {
        return this.FromId(70);
    }
    /**
		Returns School Bus Skill Test DocumentCategoryType
	**/
    get SchoolBusSkillTest(): IDocumentCategoryType {
        return this.FromId(71);
    }
    /**
		Returns Passenger Skill Test DocumentCategoryType
	**/
    get PassengerSkillTest(): IDocumentCategoryType {
        return this.FromId(72);
    }
    /**
		Returns Legal Guardian Certificate DocumentCategoryType
	**/
    get LegalGuardianCertificate(): IDocumentCategoryType {
        return this.FromId(73);
    }
    /**
		Returns Emancipated Minor Document DocumentCategoryType
	**/
    get EmancipatedMinorDocument(): IDocumentCategoryType {
        return this.FromId(74);
    }
    /**
		Returns Driving Practice Certificate DocumentCategoryType
	**/
    get DrivingPracticeCertificate(): IDocumentCategoryType {
        return this.FromId(75);
    }
    /**
		Returns Proof of Driving Training Enrollment DocumentCategoryType
	**/
    get ProofofDrivingTrainingEnrollment(): IDocumentCategoryType {
        return this.FromId(76);
    }
    /**
		Returns Proof of Veteran Status DocumentCategoryType
	**/
    get ProofofVeteranStatus(): IDocumentCategoryType {
        return this.FromId(77);
    }
    /**
		Returns Proof of Driving Experience for Class G DL DocumentCategoryType
	**/
    get ProofofDrivingExperienceforClassGDL(): IDocumentCategoryType {
        return this.FromId(78);
    }
    /**
		Returns Proof of Driving Experience for Class M DL DocumentCategoryType
	**/
    get ProofofDrivingExperienceforClassMDL(): IDocumentCategoryType {
        return this.FromId(79);
    }
    /**
		Returns Proof of Driving Experience for Class A,B,C IP DocumentCategoryType
	**/
    get ProofofDrivingExperienceforClassABCIP(): IDocumentCategoryType {
        return this.FromId(80);
    }
    /**
		Returns Proof of Driving Experience for Class A,B,C DL DocumentCategoryType
	**/
    get ProofofDrivingExperienceforClassABCDL(): IDocumentCategoryType {
        return this.FromId(81);
    }
    /**
		Returns Proof of Address - Standard DocumentCategoryType
	**/
    get ProofofAddressStandard(): IDocumentCategoryType {
        return this.FromId(82);
    }
    /**
		Returns Proof of SSN DocumentCategoryType
	**/
    get ProofofSSN(): IDocumentCategoryType {
        return this.FromId(83);
    }
    /**
		Returns Proof of Date of Birth - Commercial DocumentCategoryType
	**/
    get ProofofDateofBirthCommercial(): IDocumentCategoryType {
        return this.FromId(84);
    }
    /**
		Returns Proof of Date of Birth - Travel DocumentCategoryType
	**/
    get ProofofDateofBirthTravel(): IDocumentCategoryType {
        return this.FromId(85);
    }
    /**
		Returns Proof of Address - Commercial DocumentCategoryType
	**/
    get ProofofAddressCommercial(): IDocumentCategoryType {
        return this.FromId(86);
    }
    /**
		Returns Proof of Address - Travel DocumentCategoryType
	**/
    get ProofofAddressTravel(): IDocumentCategoryType {
        return this.FromId(87);
    }
    /**
		Returns Proof of Name - Commercial DocumentCategoryType
	**/
    get ProofofNameCommercial(): IDocumentCategoryType {
        return this.FromId(88);
    }
    /**
		Returns Proof of Name - Travel DocumentCategoryType
	**/
    get ProofofNameTravel(): IDocumentCategoryType {
        return this.FromId(89);
    }
    /**
		Returns Proof of Authorized Presence - Commercial DocumentCategoryType
	**/
    get ProofofAuthorizedPresenceCommercial(): IDocumentCategoryType {
        return this.FromId(90);
    }
    /**
		Returns Proof of Authorized Presence - Travel DocumentCategoryType
	**/
    get ProofofAuthorizedPresenceTravel(): IDocumentCategoryType {
        return this.FromId(91);
    }
    /**
		Returns Proof of Driving Experience for S Endorsement DocumentCategoryType
	**/
    get ProofofDrivingExperienceforSEndorsement(): IDocumentCategoryType {
        return this.FromId(92);
    }
    /**
		Returns Proof of Driving Experience for P Endorsement DocumentCategoryType
	**/
    get ProofofDrivingExperienceforPEndorsement(): IDocumentCategoryType {
        return this.FromId(93);
    }
    /**
		Returns Proof of No Permanent Residence DocumentCategoryType
	**/
    get ProofofNoPermanentResidence(): IDocumentCategoryType {
        return this.FromId(94);
    }
    /**
		Returns Temporary Credential DocumentCategoryType
	**/
    get TemporaryCredential(): IDocumentCategoryType {
        return this.FromId(96);
    }
    /**
		Returns Fuel Tax Refund DocumentCategoryType
	**/
    get FuelTaxRefund(): IDocumentCategoryType {
        return this.FromId(97);
    }
    /**
		Returns All Document Categories DocumentCategoryType
	**/
    get All(): IDocumentCategoryType {
        return this.FromId(98);
    }
    /**
		Returns PACE DocumentCategoryType
	**/
    get PACE(): IDocumentCategoryType {
        return this.FromId(99);
    }
    /**
		Returns Title Shell DocumentCategoryType
	**/
    get TitleShell(): IDocumentCategoryType {
        return this.FromId(100);
    }
    /**
		Returns IRP-IFTA DocumentCategoryType
	**/
    get IRPIFTA(): IDocumentCategoryType {
        return this.FromId(101);
    }
    /**
		Returns Court Paper Abstracts DocumentCategoryType
	**/
    get CourtPaperAbstracts(): IDocumentCategoryType {
        return this.FromId(102);
    }
    /**
		Returns Law Enforcement Affidavit DocumentCategoryType
	**/
    get LawEnforcementAffidavit(): IDocumentCategoryType {
        return this.FromId(103);
    }
    /**
		Returns Renewal Invitations DocumentCategoryType
	**/
    get RenewalInvitations(): IDocumentCategoryType {
        return this.FromId(104);
    }
    /**
		Returns Out of State Credential Number Verification DocumentCategoryType
	**/
    get OOSCredentialNumberVerification(): IDocumentCategoryType {
        return this.FromId(95);
    }
    /**
        Returns ATP Agreements DocumentCategoryType
    **/
    get ATPAgreements(): IDocumentCategoryType {
        return this.FromId(123);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('10', { id: 10, value: 'DriverIdentityName', displayValue: 'Driver Identity - Name', description: 'Documents showing name', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'DriverIdentityDOB', displayValue: 'Driver Identity - DOB', description: 'Documents showing date of birth', sortOrder: 20, active: true });
        this._dictionary.add('12', { id: 12, value: 'DriverIdentityAuthorizedPresence', displayValue: 'Driver Identity - Authorized Presence', description: 'Documents indicating authorized presence', sortOrder: 30, active: true });
        this._dictionary.add('39', { id: 39, value: 'DriverIdentitySecondaryAuthorizedPresence', displayValue: 'Driver Identity - Secondary Authorized Presence', description: 'Secondary Documents indicating authorized presence', sortOrder: 35, active: true });
        this._dictionary.add('13', { id: 13, value: 'DriverDocsSSN', displayValue: 'Driver Docs - SSN', description: 'Documents proving social security number', sortOrder: 40, active: true });
        this._dictionary.add('14', { id: 14, value: 'DriverDocsAddress', displayValue: 'Driver Docs - Address', description: 'Documents proving address', sortOrder: 50, active: true });
        this._dictionary.add('18', { id: 18, value: 'DriverDocsKnowledge&Skills', displayValue: 'Driver Docs - Knowledge & Skills', description: 'Documents waiving knowledge & Skills Exams', sortOrder: 60, active: true });
        this._dictionary.add('20', { id: 20, value: 'DriverDocsVeteran', displayValue: 'Driver Docs - Veteran', description: 'Documents proving veteran and/or military status', sortOrder: 70, active: true });
        this._dictionary.add('21', { id: 21, value: 'DriverDocsMedical/Vision', displayValue: 'Driver Docs - Medical/Vision', description: 'Documents determining fitness to operate a motor vehicle', sortOrder: 80, active: true });
        this._dictionary.add('19', { id: 19, value: 'DriverDocsDriverExperience', displayValue: 'Driver  Docs - Driver Experience', description: 'Documents proving driver experience', sortOrder: 90, active: true });
        this._dictionary.add('17', { id: 17, value: 'DriverDocsMinor', displayValue: 'Driver Docs - Minor', description: 'Documents authorizing a minor to obtain a license', sortOrder: 100, active: true });
        this._dictionary.add('15', { id: 15, value: 'DriverIdentityNameChange', displayValue: 'Driver Identity - Name Change', description: 'Documents proving a name change', sortOrder: 120, active: true });
        this._dictionary.add('16', { id: 16, value: 'DriverIdentityGenderChange', displayValue: 'Driver Identity - Gender Change', description: 'Document proving a gender change', sortOrder: 130, active: true });
        this._dictionary.add('1', { id: 1, value: 'Placard', displayValue: 'Placard', description: 'Placard', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Military', displayValue: 'Military', description: 'Military', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'FeeExemptions', displayValue: 'Fee Exemptions', description: 'Fee Exemptions', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'VehicleOwnership', displayValue: 'Vehicle Ownership', description: 'Vehicle Ownership', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Identity', displayValue: 'Identity', description: 'Identity', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Other', displayValue: 'Other', description: 'Other', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'MVDNow', displayValue: 'MVD Now', description: 'MVD Now', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'IAFFApplication', displayValue: 'International Association of Fire Fighters Application', description: 'International Association of Fire Fighters Application', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'FOPApplication', displayValue: 'Fraternal Order of Police Application', description: 'Fraternal Order of Police Application', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: 'AbandonedVehicle', displayValue: 'Abandoned Vehicle', description: 'Abandoned Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: 'AdditionalDocumentation', displayValue: 'Additional Documentation', description: 'Additional Documentation', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: 'TnRTitleRoleTypeCourtOrder', displayValue: 'Court Order', description: 'Court Order', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, value: 'Registration', displayValue: 'Registration Documents', description: 'Registration Documents', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, value: 'Plate', displayValue: 'License Plate Documents', description: 'License Plate Documents', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, value: 'Lien', displayValue: 'Lien Documents', description: 'Lien Documents', sortOrder: 999999, active: true });
        this._dictionary.add('28', { id: 28, value: 'Permit', displayValue: 'Permit', description: 'Permit', sortOrder: 999999, active: true });
        this._dictionary.add('32', { id: 32, value: 'Compliance', displayValue: 'Compliance Documents', description: 'Compliance Documents', sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, value: 'TitleSummary', displayValue: 'Title Summary', description: 'Title Summary', sortOrder: 999999, active: true });
        this._dictionary.add('34', { id: 34, value: 'TempLicensePlateTempRegistration', displayValue: 'Temp License Plate Temp Registration', description: 'Temp License Plate Temp Registration', sortOrder: 999999, active: true });
        this._dictionary.add('35', { id: 35, value: 'VehicleRegistration', displayValue: 'Vehicle Registration', description: 'Vehicle Registration', sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, value: 'InterimPlacard', displayValue: 'Interim Placard', description: 'Interim Placard', sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, value: 'VehicleMVR', displayValue: 'Vehicle MVR', description: 'Vehicle MVR', sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, value: 'MotorVehicleRecordArtifact', displayValue: 'Motor Vehicle Record Artifact', description: 'Motor Vehicle Record Artifact', sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, value: 'RefundReceipt', displayValue: 'Refund Receipt', description: 'Refund Receipt', sortOrder: 999999, active: true });
        this._dictionary.add('41', { id: 41, value: 'PaymentReceipt', displayValue: 'Payment Receipt', description: 'Payment Receipt', sortOrder: 999999, active: true });
        this._dictionary.add('42', { id: 42, value: 'Correspondence', displayValue: 'Correspondence', description: 'Correspondence', sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, value: 'ProofofAuthorizedPresenceStandard', displayValue: 'Proof of Authorized Presence - Standard', description: 'Documents Proving Authorized Presence for a standard credential', sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, value: 'ProofofNameStandard', displayValue: 'Proof of Name - Standard', description: 'Documents Proving Legal Name for a standard credential', sortOrder: 999999, active: true });
        this._dictionary.add('45', { id: 45, value: 'ProofofNameChange', displayValue: 'Proof of Name Change', description: 'Documents proving Legal Name change', sortOrder: 999999, active: true });
        this._dictionary.add('46', { id: 46, value: 'ProofofGenderChange', displayValue: 'Proof of Gender Change', description: 'Documents proving  gender change', sortOrder: 999999, active: true });
        this._dictionary.add('47', { id: 47, value: 'ProofofDateofBirthStandard', displayValue: 'Proof of Date of Birth- Standard', description: 'Documents proving date of birth for a standard credential', sortOrder: 999999, active: true });
        this._dictionary.add('48', { id: 48, value: 'VisionScreening', displayValue: 'Vision Screening', description: 'Documents proving Vision Ability', sortOrder: 999999, active: true });
        this._dictionary.add('49', { id: 49, value: 'VisionScreeningRe-Exam', displayValue: 'Vision Screening Re-Exam', description: 'Documents proving Vision Ability', sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, value: 'VisionExamReport', displayValue: 'Vision Exam Report', description: 'Documents proving Vision Ability', sortOrder: 999999, active: true });
        this._dictionary.add('51', { id: 51, value: 'MedicalExamReport ', displayValue: 'Medical Exam Report ', description: 'MVD Form completed by a Physician', sortOrder: 999999, active: true });
        this._dictionary.add('52', { id: 52, value: 'MedicalExamCertificate', displayValue: 'Medical Exam Certificate', description: 'Record of Medical Exam for CDL Driver', sortOrder: 999999, active: true });
        this._dictionary.add('53', { id: 53, value: 'MedicalProfessionalStatement', displayValue: 'Medical Professional Statement', description: 'Statement from Professional verifying a Medical Alert', sortOrder: 999999, active: true });
        this._dictionary.add('54', { id: 54, value: 'SubstanceAbuseEvalutation', displayValue: 'Substance Abuse Evalutation', description: 'MVD form completed by Counselor/Physician/Psychologist', sortOrder: 999999, active: true });
        this._dictionary.add('55', { id: 55, value: 'NonCommercialKnowledge', displayValue: 'Non Commercial Knowledge', description: 'Documents that satisfy Non-Commercial driving knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('56', { id: 56, value: 'NonCommercialKnowledgeReExam', displayValue: 'Non Commercial Knowledge Re-Exam', description: 'Documents that satisfy Non-Commercial driving knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('57', { id: 57, value: 'MotorcycleKnowledge', displayValue: 'Motorcycle Knowledge', description: 'Documents that satisfy Motorcycle driving knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('58', { id: 58, value: 'ClassAKnowledge', displayValue: 'Class A Knowledge ', description: 'Documents that satisfy Class A driving Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('59', { id: 59, value: 'ClassBKnowledge', displayValue: 'Class B Knowledge ', description: 'Documents that satisfy Class B driving Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, value: 'ClassCKnowledge', displayValue: 'Class C Knowledge ', description: 'Documents that satisfy Class C driving Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, value: 'DoubleTripleKnowledge', displayValue: 'Double/Triple  Knowledge', description: 'Documents that satisfy Double/Triple  Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, value: 'PassengerKnowledge', displayValue: 'Passenger Knowledge', description: 'Documents that satisfy Passenger Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, value: 'SchoolBusknowledge', displayValue: 'School Bus Knowledge', description: 'Documents that satisfy School Bus Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, value: 'TankKnowledge', displayValue: 'Tank Knowledge', description: 'Documents that satisfy Tank Knowledge', sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, value: 'NonCommercialSkillTest', displayValue: 'Non Commercial Skill Test', description: 'Documents that satisfy Non Commercial Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, value: 'NonCommercialSkillTestRe-Exam', displayValue: 'Non Commercial Skill Test Re-Exam', description: 'Documents that satisfy Non Commercial Skill Test Re-Exam', sortOrder: 999999, active: true });
        this._dictionary.add('67', { id: 67, value: 'MotorcycleSkillTest', displayValue: 'Motorcycle Skill Test', description: 'Documents that satisfy Motorcycle Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('68', { id: 68, value: 'ClassASkillTest', displayValue: 'Class A Skill Test', description: 'Documents that satisfy Class A Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('69', { id: 69, value: 'ClassBSkillTest', displayValue: 'Class B Skill Test', description: 'Documents that satisfy Class B Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('70', { id: 70, value: 'ClassCSkillTest', displayValue: 'Class C Skill Test', description: 'Documents that satisfy Class C Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('71', { id: 71, value: 'SchoolBusSkillTest', displayValue: 'School Bus Skill Test', description: 'Documents that satisfy School Bus Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('72', { id: 72, value: 'PassengerSkillTest', displayValue: 'Passenger Skill Test', description: 'Documents that satisfy Passenger Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('73', { id: 73, value: 'LegalGuardianCertificate', displayValue: 'Legal Guardian Certificate', description: 'Documents certifying legal responsibility of a minor child', sortOrder: 999999, active: true });
        this._dictionary.add('74', { id: 74, value: 'EmancipatedMinorDocument', displayValue: 'Emancipated Minor Document', description: 'Documents declaring a minor as emancipated', sortOrder: 999999, active: true });
        this._dictionary.add('75', { id: 75, value: 'DrivingPracticeCertificate', displayValue: 'Driving Practice Certificate', description: 'Documents Certifying driving practice hours', sortOrder: 999999, active: true });
        this._dictionary.add('76', { id: 76, value: 'ProofofDrivingTrainingEnrollment', displayValue: 'Proof of Driving Training Enrollment', description: 'documents proving enrollment in a driver training program', sortOrder: 999999, active: true });
        this._dictionary.add('77', { id: 77, value: 'ProofofVeteranStatus', displayValue: 'Proof of Veteran Status', description: 'Documents proving active duty, reserve or honorable discharge', sortOrder: 999999, active: true });
        this._dictionary.add('78', { id: 78, value: 'ProofofDrivingExperienceforClassGDL', displayValue: 'Proof of Driving Experience for Class G DL', description: 'Document proving the duration of issued license experience', sortOrder: 999999, active: true });
        this._dictionary.add('79', { id: 79, value: 'ProofofDrivingExperienceforClassMDL', displayValue: 'Proof of Driving Experience for Class M DL', description: 'Document proving the duration of issued license experience', sortOrder: 999999, active: true });
        this._dictionary.add('80', { id: 80, value: 'ProofofDrivingExperienceforClassABCIP', displayValue: 'Proof of Driving Experience for Class A,B,C IP', description: 'Document proving the duration of issued license experience', sortOrder: 999999, active: true });
        this._dictionary.add('81', { id: 81, value: 'ProofofDrivingExperienceforClassABCDL', displayValue: 'Proof of Driving Experience for Class A,B,C DL', description: 'Document proving the duration of issued license experience', sortOrder: 999999, active: true });
        this._dictionary.add('82', { id: 82, value: 'ProofofAddressStandard', displayValue: 'Proof of Address - Standard', description: 'Document proving current address for a standard credential', sortOrder: 999999, active: true });
        this._dictionary.add('83', { id: 83, value: 'ProofofSSN', displayValue: 'Proof of SSN', description: 'SSN Card', sortOrder: 999999, active: true });
        this._dictionary.add('84', { id: 84, value: 'ProofofDateofBirthCommercial', displayValue: 'Proof of Date of Birth - Commercial', description: 'Document proving date of birth for a commercial credential', sortOrder: 999999, active: true });
        this._dictionary.add('85', { id: 85, value: 'ProofofDateofBirthTravel', displayValue: 'Proof of Date of Birth - Travel', description: 'Document proving date of birth for a travel credential', sortOrder: 999999, active: true });
        this._dictionary.add('86', { id: 86, value: 'ProofofAddressCommercial', displayValue: 'Proof of Address - Commercial', description: 'Document proving current address for a commercial credential', sortOrder: 999999, active: true });
        this._dictionary.add('87', { id: 87, value: 'ProofofAddressTravel', displayValue: 'Proof of Address - Travel', description: 'Document proving current address for a travel credential', sortOrder: 999999, active: true });
        this._dictionary.add('88', { id: 88, value: 'ProofofNameCommercial', displayValue: 'Proof of Name - Commercial', description: 'Document Proving Legal Name for a Commercial credential', sortOrder: 999999, active: true });
        this._dictionary.add('89', { id: 89, value: 'ProofofNameTravel', displayValue: 'Proof of Name - Travel', description: 'Document Proving Legal Name for a Travel credential', sortOrder: 999999, active: true });
        this._dictionary.add('90', { id: 90, value: 'ProofofAuthorizedPresenceCommercial', displayValue: 'Proof of Authorized Presence - Commercial', description: 'Document Proving Authorized Presence for a commercial credential', sortOrder: 999999, active: true });
        this._dictionary.add('91', { id: 91, value: 'ProofofAuthorizedPresenceTravel', displayValue: 'Proof of Authorized Presence - Travel', description: 'Document Proving Authorized Presence for a travel credential', sortOrder: 999999, active: true });
        this._dictionary.add('92', { id: 92, value: 'ProofofDrivingExperienceforSEndorsement', displayValue: 'Proof of Driving Experience for S Endorsement', description: 'Document Proving Driving Experience for S Endorsement', sortOrder: 999999, active: true });
        this._dictionary.add('93', { id: 93, value: 'ProofofDrivingExperienceforPEndorsement', displayValue: 'Proof of Driving Experience for P Endorsement', description: 'Document Proving Driving Experience for P Endorsement', sortOrder: 999999, active: true });
        this._dictionary.add('94', { id: 94, value: 'ProofofNoPermanentResidence', displayValue: 'Proof of No Permanent Residence', description: 'Proof of Homelessness', sortOrder: 999999, active: true });
        this._dictionary.add('96', { id: 96, value: 'TemporaryCredential', displayValue: 'Temporary Credential', description: 'Temporary Credential', sortOrder: 999999, active: true });
        this._dictionary.add('95', { id: 95, value: 'OOSCredentialNumberVerification', displayValue: 'Out of State Credential Number Verification', description: 'Out of State Credential Number Verification', sortOrder: 9999999, active: true });
        this._dictionary.add('97', { id: 97, value: 'FuelTaxRefund', displayValue: 'Fuel Tax Refund', description: 'Fuel Tax Refund', sortOrder: 999999, active: true });
        this._dictionary.add('98', { id: 98, value: 'All', displayValue: 'All Document Categories', description: 'All Document Categories', sortOrder: 9, active: true });
        this._dictionary.add('99', { id: 99, value: 'PACE', displayValue: 'PACE', description: 'Withdrawal related documents generated from PACE (prohibition and compliance engine)', sortOrder: 999999, active: true });
        this._dictionary.add('100', { id: 100, value: 'TitleShell', displayValue: 'Title Shell', description: 'Title Shell', sortOrder: 999999, active: true });
        this._dictionary.add('101', { id: 101, value: 'IRP-IFTA', displayValue: 'IRP-IFTA', description: 'IRP-IFTA', sortOrder: 999999, active: true });
        this._dictionary.add('102', { id: 102, value: 'CourtPaperAbstracts', displayValue: 'Court Paper Abstracts', description: 'Court Paper Abstracts', sortOrder: 999999, active: true });
        this._dictionary.add('103', { id: 103, value: 'LawEnforcementAffidavit', displayValue: 'Law Enforcement Affidavit', description: 'Law Enforcement Affidavit', sortOrder: 999999, active: true });
        this._dictionary.add('104', { id: 104, value: 'RenewalInvitations', displayValue: 'Renewal Invitations', description: 'Renewal Invitations - fleet and individual vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('123', { id: 123, value: 'ATPAgreements', displayValue: 'ATP Agreements', description: 'ATP Agreements', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDocumentCategoryType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDocumentCategoryType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDocumentCategoryType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDocumentCategoryType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDocumentCategoryType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
